<template>
    <div> 
            <!-- Header Row with Flexbox -->
            <b-container class="pt-1">
            <b-row class="d-flex justify-content-between align-items-center">
                <!-- Cash Calls Label -->
                <h5 class="header">&nbsp;</h5>
                <!-- New Button --> 
                 <div>
                <BaseButton v-if="canCreateCashCall" class="newBtn" @click="newCashCall">Create New</BaseButton>       
                <!-- <a 
          @click.prevent="newCashCall"
          class="text-underline  mr-5 font-weight-bold"
          href
          >New</a>         -->
                <!-- <BaseButton class="newBtn" @click="openModal">New (Slider)</BaseButton>
                -->
                </div>
            </b-row>
        </b-container>
        <CashCallManagementTable
            ref="tableRef"
            v-model="selectedIds"
            :selected="selectedIds"
            @edit:item="(item) => setActiveCashCall(item)"
            >
            <template v-slot:header(bottom)>
                <BaseButton
                v-if="!!selectedIds.length"
                class="ml-3 disabled"
                disabled
                @click="() => (showCashCallModal = true)"
                >Edit</BaseButton
                >
            </template>
        </CashCallManagementTable>
        <CashCallCreateModal
         :key="activeCashCall && activeCashCall.id || 'new'"
         v-model="showCashCallModal"
         @success="onEditModalSuccess"
         :id = "activeCashCall && activeCashCall.id"
         :status = "activeCashCall && activeCashCall.status || 'DRAFT'"
         :claim_loss_established = "activeCashCall ? activeCashCall.claim_loss_established !== false : true"
         :claim_authority_scope = "activeCashCall ? activeCashCall.claim_authority_scope !== false : true"
         :claim_reason = "activeCashCall &&  activeCashCall.claim_reason || undefined"
         :bdx_key_exists = "activeCashCall && activeCashCall.bdx_key_exists || true"
         :bdx_key = "activeCashCall &&  activeCashCall.bdx_key || undefined"
         :claim_ref = "activeCashCall &&  activeCashCall.claim_ref || undefined"
         :loss_country = "activeCashCall &&  activeCashCall.loss_country || undefined"
         :loss_state = "activeCashCall &&  activeCashCall.loss_state || undefined"
         :loss_sl_state = "activeCashCall &&  activeCashCall.loss_sl_state || undefined"
         :loss_province = "activeCashCall &&  activeCashCall.canada_province || undefined"
         :broker = "activeCashCall &&  activeCashCall.broker || undefined"
         :naic_code = "activeCashCall &&  activeCashCall.naic_code || ''"
         :cause_of_loss = "activeCashCall &&  activeCashCall.cause_of_loss || ''"
         :tpa = "activeCashCall &&  activeCashCall.tpa || ''"
         :coverholder = "activeCashCall &&  activeCashCall.coverholder || ''"
         :underwriter_lead = "activeCashCall &&  activeCashCall.underwriter_lead || ''"
         :sanctions_status = "activeCashCall &&  activeCashCall.sanction_status || undefined"
         :insured_name = "activeCashCall &&  activeCashCall.insured_name || ''"
         :date_of_loss = "activeCashCall &&  activeCashCall.date_of_loss || ''"
         :date_claim_made = "activeCashCall &&  activeCashCall.date_claim_made || ''"
         :date_risk_effective = "activeCashCall &&  activeCashCall.date_risk_effective || ''"
         :date_risk_expiry = "activeCashCall &&  activeCashCall.date_risk_expiry || ''"
         :date_recent_report_period = "activeCashCall &&  activeCashCall.date_recent_report_period || ''"
         :amount = "activeCashCall &&  activeCashCall.amount || 0.0"
         :total_fee = "activeCashCall &&  activeCashCall.total_fee || 0.0"
         :adjusters_fee = "activeCashCall &&  activeCashCall.adjuster_fee_amount || 0.0"
         :defence_fee = "activeCashCall &&  activeCashCall.defence_fees_amount || 0.0"
         :attorney_fee = "activeCashCall &&  activeCashCall.attorney_coverage_amount || 0.0"
         :tpa_fee = "activeCashCall &&  activeCashCall.tpa_fees_amount || 0.0"
         :total_indemnity = "activeCashCall &&  activeCashCall.total_indemnity || 0.0"
         :expenses = "activeCashCall &&  activeCashCall.expenses_amount || 0.0"
         :initial_loss_fund_value = "activeCashCall &&  activeCashCall.initial_loss_fund_value || 0.0"
         :current_loss_fund_balance = "activeCashCall &&  activeCashCall.current_loss_fund_balance || 0.0"
         :fee_exists = "activeCashCall &&  activeCashCall.fee_exists || false"
         :supporting_documents = "activeCashCall && activeCashCall.supporting_documents || []"
         :cash_call_comments = "activeCashCall &&  activeCashCall.cash_call_comments || ''"
         :statutory_deadline = "activeCashCall &&  activeCashCall.statutory_deadline || ''"
         :is_co_lead = "activeCashCall && activeCashCall.is_co_lead || false"
         :keys = "activeCashCall && activeCashCall.keys || []"

         is-modal />      
        <b-modal
        id="emailPromptModal"
        v-model="showEmailPrompt"
        title="Email Cash Call Now?"
        hide-footer
        >
            <p>
                Do you want to email the Cash Call now?
            </p>

            <div class="d-flex justify-content-end mt-3">
                <b-button variant="secondary" class="mr-2" @click="closeEmailPromptAndRefresh">
                Later
                </b-button>

                <b-button variant="primary" @click="openEmailModalAfterCreate">
                Yes
                </b-button>
            </div>
        </b-modal>

        <!-- CO-LEAD: "Email Co-Lead Cash Call Now?" prompt. Owned by this page
             (not the wizard) so it survives the wizard closing after Compile. -->
        <b-modal
            id="coleadEmailPromptModal"
            v-model="showColeadEmailPrompt"
            title="Email Cash Call - Co-Lead Now?"
            hide-footer
        >
            <p>Do you want to email the Cash Call - Co-Lead now?</p>
            <div class="d-flex justify-content-end mt-3">
                <b-button variant="secondary" class="mr-2" @click="onColeadEmailLater">Later</b-button>
                <b-button variant="primary" @click="onColeadEmailNow">Yes</b-button>
            </div>
        </b-modal>

        <!-- CO-LEAD recipient-select modal (normal-style single dropdown). -->
        <CashCallFormSubmit
            v-model="showColeadRecipientModal"
            :cash-call="coleadRecipientCashCall"
            title="Send Cash Call - Co-Lead"
            :broker-required="true"
            @submit="onColeadRecipientSubmit"
            @close="showColeadRecipientModal = false"
        />

    </div>
</template>


<script>
import Vue from 'vue'
import {
    defineComponent,
    computed,
    ref,
    watch,
    nextTick,
    onMounted
} from '@vue/composition-api'
import { BaseButton } from '@components/base'
import { useAuth } from "@composables/auth";
import { useActiveBDX, useUserCompany, useActiveCashCall } from '@composables'
import CashCallCreateModal from '@components/CashCall/CashCallCreateModal.vue'
import CashCallFormSubmit from '@components/CashCall/CashCallFormSubmit.vue'
import MySlidingModal from '@components/CashCall/MySlidingModal.vue';
import { CashCallManagementTable } from '@components/CashCall';
import { generateColeadPdfBlob } from '../util/cashCallColeadPdf'
import CashCallService from '../services/CashCallService'


export default defineComponent({
    name: 'CashCallDetails',
    components: {
        BaseButton,
        CashCallCreateModal,
        CashCallFormSubmit,
        CashCallManagementTable,
        MySlidingModal
    },
    data() {
        return {
        showModal: false,
        };
    },
    methods: {
        openModal() {
        this.showModal = true;
        //this.showCashCallModal = true;
        },
        closeModal() {
        this.showModal = false;
        //this.showCashCallModal = false;
        }        

    },
    setup() {
        const { currentUser } = useAuth()
        const showCashCallModal = ref(false)
        const { activeCashCall, setActiveCashCall, resetActiveCashCall } = useActiveCashCall()

        const showEmailPrompt = ref(false)
        const createdCashCallId = ref(null)

        // ---- Co-Lead email flow (owned here so it survives the wizard closing
        // after "Compile Cash Call") ----
        const showColeadEmailPrompt = ref(false)
        const showColeadRecipientModal = ref(false)
        const coleadEmailPayload = ref(null)     // snapshot emitted by the wizard
        const coleadRecipientCashCall = ref(null) // {id, cash_call_reference, recipient_emails}

        const formatColeadMoney = (value) => {
            const n = Number(value) || 0
            return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }

        // "Later": don't email. Prompt closes; list already refreshed on compile.
        const onColeadEmailLater = () => {
            showColeadEmailPrompt.value = false
        }

        // "Yes": open the normal-style recipient dropdown for the co-lead cash call.
        const onColeadEmailNow = () => {
            const p = coleadEmailPayload.value
            if (!p || !p.cashCallId) {
                Vue.prototype.$toasted.show('Please save the cash call before sending.')
                return
            }
            coleadRecipientCashCall.value = {
                id: p.cashCallId,
                cash_call_reference: p.reference || '',
                recipient_emails: p.recipientEmails || ''
            }
            showColeadEmailPrompt.value = false
            showColeadRecipientModal.value = true
        }

        // `submit` from CashCallFormSubmit: build ONE combined co-lead PDF and
        // email it to all selected recipients. Runs inside the modal's SweetAlert
        // preConfirm, so re-throw on failure to surface the error there.
        const onColeadRecipientSubmit = async (submitPayload) => {
            const p = coleadEmailPayload.value || {}
            try {
                const recipients = (submitPayload && submitPayload.person) || []
                const cashCallId = (submitPayload && submitPayload.cashCallId) || p.cashCallId
                const reference = p.reference || 'cash-call'
                const emails = Array.isArray(recipients) ? recipients.join(',') : (recipients || '')

                const pdfBlob = await generateColeadPdfBlob({
                    cashCall: p.pdfContext || {},
                    keys: p.keys || [],
                    recipients: recipients || [],
                    requestor: p.requestor || {}
                })

                // The modal now tracks recipients PER UMR (each key emails only
                // the people picked under it) and emits that structure directly.
                // Fall back to the old "same list on every key" shape only if a
                // per-key selection wasn't provided (older callers).
                const recipientsByKey = (submitPayload && submitPayload.recipientsByKey && submitPayload.recipientsByKey.length)
                    ? submitPayload.recipientsByKey
                    : (p.keys || []).map((k) => {
                        const bdx = Array.isArray(k.bdx_key) ? k.bdx_key[0] : k.bdx_key
                        return {
                            key_id: k.id ? String(k.id) : (bdx ? 'bdx:' + bdx : 'umr:' + (k.umr || '')),
                            bdx_key: bdx || '',
                            umr: k.umr || '',
                            underwriter_lead: k.underwriter_lead || '',
                            recipients: recipients,
                            recipients_by_role: { broker: [] }
                        }
                    })

                const formData = new FormData()
                formData.append('cashcall_id', cashCallId)
                formData.append('recipient_email', emails)
                formData.append('is_co_lead', true)
                formData.append('recipients_by_key', JSON.stringify(recipientsByKey))
                formData.append('attachment', pdfBlob, `CashCall-${reference}.pdf`)
                // Urgency options: high importance flag + URGENT subject prefix.
                formData.append('high_importance', (submitPayload && submitPayload.highImportance) ? 'true' : 'false')
                formData.append('urgent', (submitPayload && submitPayload.urgent) ? 'true' : 'false')
                await CashCallService.sendEmail(formData)

                Vue.prototype.$toasted.show('Cash Call - Co-Lead sent successfully')
                Vue.prototype.$emitter.emit('cashcall:email-sent', { id: cashCallId })
                showColeadRecipientModal.value = false
            } catch (err) {
                console.error('Co-Lead send failed:', err)
                // Show the backend's reason when it gives one (e.g. "UMR shares
                // add up to 30%, not 100%..." for a partly allocated draft).
                const reason = err && err.response && err.response.data && err.response.data.detail
                Vue.prototype.$toasted.show(
                  reason ? `Failed to send Cash Call - Co-Lead: ${reason}` : 'Failed to send Cash Call - Co-Lead'
                )
                throw err
            }
        }


        const newCashCall = () => {
            resetActiveCashCall()
            showCashCallModal.value = true        
        }
            // Selected items
        const selectedIds = ref([])

        const onEditModalSuccess = async () => {
            showCashCallModal.value = false
        }

        

        const closeEmailPromptAndRefresh = () => {
        showEmailPrompt.value = false

        Vue.prototype.$emitter.emit("cashcall:email-sent", {
              id: activeCashCall.id,
              });
        }

        const openEmailModalAfterCreate = () => {
        showEmailPrompt.value = false

        Vue.prototype.$emitter.emit('cashcall:open-email-modal', {
            cashCall: activeCashCall.value
        })
        }


        const confirmEmailSend = async () => {
        showEmailPrompt.value = false

        const result = await Vue.prototype.$swal({
            title: "Are you sure?",
            text: "Once emailed, the form cannot be modified.",
            showCancelButton: true,
            confirmButtonText: "Yes, send email",
            cancelButtonText: "No",
            buttonsStyling: false,
            customClass: {
            confirmButton: "swal-confirm-btn",
            cancelButton: "swal-cancel-btn"
            }
        })

        if (!result.isConfirmed) return

        Vue.prototype.$emitter.emit('cashcall:open-email-modal', {
            cashCall: activeCashCall.value
                })
        }



        watch(showCashCallModal, (newShowCashCallModal) => {
            if (newShowCashCallModal) {
                return 
            }

        })

        watch(
            activeCashCall,
            async (newActiveCashCall) => {
                if (!!selectedIds.value.length) return
                if (newActiveCashCall && newActiveCashCall.id) {
                    showCashCallModal.value = false
                    await nextTick()
                    // Only open if editing
                    showCashCallModal.value = true
                }
            },
            { deep: true }
        )

        const canCreateCashCall = computed(() => {
            return currentUser.value && (currentUser.value.cash_call_role === 'TPA' || currentUser.value.role === 'Superuser')
        })

        const handleShowCashCallStatus = () => {
            showCashCallModal = true;
            alert('This Page is under construction');
        }
        const tableRef = ref(null)
        // Edit modal        

        onMounted(async() => {
          Vue.prototype.$emitter.on('cash-call-form:success', async (payload) => {
              await nextTick()
              showEmailPrompt.value = true
          });

          // Co-lead: wizard finished "Compile Cash Call" and closed itself. Show
          // our "Email Co-Lead Cash Call Now?" prompt with the emitted snapshot.
          Vue.prototype.$emitter.on('cashcall:colead-compiled', async (payload) => {
              coleadEmailPayload.value = payload || null
              await nextTick()
              showColeadEmailPrompt.value = true
          });
          const directLink = sessionStorage.getItem('directLink')

          if (directLink) {
            sessionStorage.removeItem('directLink')

            try {
              const parsed = JSON.parse(directLink)
              const cashCallId = parsed && parsed.cashCallId
              const bdxKey = parsed && parsed.bdxKey
              const action = parsed && parsed.action || 'Edit'

              if (cashCallId) {
                await nextTick()
                Vue.prototype.$emitter.emit('cashcall:open-by-id', {
                  cashCallId: cashCallId,
                  bdxKey: bdxKey || null,
                  action: action,
                  // From a TPA approval email's Approve link (see CashCallRedirect).
                  urgent: !!parsed.urgent,
                  highImportance: !!parsed.highImportance
                })
              }
            } catch (e) {
              console.error('Failed to parse direct link data', e)
            }
          }
        });

        return {
            currentUser,
            tableRef,
            showCashCallModal,
            handleShowCashCallStatus,
            onEditModalSuccess,
            newCashCall,
            showEmailPrompt,
            createdCashCallId,
            selectedIds,
            activeCashCall,
            setActiveCashCall,
            resetActiveCashCall,
            canCreateCashCall,
            confirmEmailSend,
            openEmailModalAfterCreate,
            closeEmailPromptAndRefresh,
            // Co-lead email flow
            showColeadEmailPrompt,
            showColeadRecipientModal,
            coleadEmailPayload,
            coleadRecipientCashCall,
            formatColeadMoney,
            onColeadEmailLater,
            onColeadEmailNow,
            onColeadRecipientSubmit
        }

    }
})
</script>

<style scoped>
.header {
    padding-left:25px;
    padding-top:25px;
    font-size:1.3125rem
}
.newBtn {
    margin-right: 40px; 
}
</style>